import { useParams } from 'react-router-dom';
import { marketingData } from '@/data/marketingData';
import CMSDetailPage from '@/components/CMSDetailPage';

export default function MarketingDetail() {
  const { id } = useParams<{ id: string }>();
  const item = marketingData.find((i) => i.id === Number(id));

  if (!item) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>内容不存在</p>
      </div>
    );
  }

  return (
    <CMSDetailPage
      title={item.title}
      description={item.description}
      image={item.image}
      updateTime={item.updateTime}
      views={item.views}
      category="营销中心"
      categoryPath="/marketing"
      content={item.content}
      features={item.features}
    />
  );
}
